import { Link } from "react-router-dom";
import { UtensilsCrossed, PartyPopper, MessageSquare, ShoppingBag } from "lucide-react";
import { useEnquiry } from "@/components/public/EnquiryProvider";
import { useSettings } from "@/components/public/shared";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function MobileBar() {
  const { open } = useEnquiry();
  const s = useSettings();
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-4 border-t border-subtle bg-ivory/95 backdrop-blur-xl lg:hidden">
      <Link to="/menu" data-testid="mobilebar-menu" className="flex flex-col items-center gap-1 py-2.5 text-[10px] font-semibold uppercase tracking-wider text-espresso/80">
        <UtensilsCrossed className="h-5 w-5 text-gold" /> Menu
      </Link>
      <button onClick={() => open("event")} data-testid="mobilebar-catering" className="flex flex-col items-center gap-1 py-2.5 text-[10px] font-semibold uppercase tracking-wider text-espresso/80">
        <PartyPopper className="h-5 w-5 text-gold" /> Catering
      </button>
      <button onClick={() => open("contact")} data-testid="mobilebar-enquire" className="flex flex-col items-center gap-1 py-2.5 text-[10px] font-semibold uppercase tracking-wider text-espresso/80">
        <MessageSquare className="h-5 w-5 text-gold" /> Enquire
      </button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button data-testid="mobilebar-order" className="flex flex-col items-center gap-1 py-2.5 text-[10px] font-semibold uppercase tracking-wider text-espresso/80">
            <ShoppingBag className="h-5 w-5 text-gold" /> Order
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-ivory border-subtle mb-2">
          <DropdownMenuItem asChild><a href={s.zomato_url || "#"} target="_blank" rel="noreferrer">Zomato</a></DropdownMenuItem>
          <DropdownMenuItem asChild><a href={s.swiggy_url || "#"} target="_blank" rel="noreferrer">Swiggy</a></DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
